import { EditorView } from "@codemirror/view"
import { HighlightStyle, tags } from "@codemirror/highlight"

// modified from https://github.com/codemirror/theme-one-dark/blob/main/src/one-dark.ts
const chalky = "#e5c07b",
  coral = "#e06c75",
  cyan = "#56b6c2",
  invalid = "#ffffff",
  ivory = "#ffffff",
  stone = "#7d8799", // Brightened compared to original to increase contrast
  malibu = "#61afef",
  sage = "#98c379",
  whiskey = "#d19a66",
  violet = "#c678dd",
  darkBackground = "#21252b",
  highlightBackground = "#2C3137",
  background = "#3A3D40",
  tooltipBackground = "#353a42",
  selection = "#7A7C7E",
  cursor = "#ffffff"

const LabeledTextFieldTheme = EditorView.theme(
  {
    "&": {
      color: ivory,
      backgroundColor: background,
    },
    ".cm-content": {
      caretColor: cursor,
      cursor: "text",
      padding: "0px",
    },
    ".cm-lineNumbers .cm-gutterElement": { paddingLeft: "0px !important", minWidth: "0px" },
    "&.cm-focused .cm-cursor": { borderLeftColor: cursor },
    "&.cm-focused .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": {
      backgroundColor: selection,
    },
    "&.cm-editor": {
      borderRadius: "0.75rem",
      marginBottom: "0.75rem",
      padding: "0.5rem 0.75rem",
    },
    ".cm-scroller": { overflow: "auto" },
    ".cm-panels": { backgroundColor: darkBackground, color: ivory },
    ".cm-panels.cm-panels-top": { borderBottom: "2px solid black" },
    ".cm-panels.cm-panels-bottom": { borderTop: "2px solid black" },
    ".cm-searchMatch": {
      backgroundColor: "#72a1ff59",
      outline: "1px solid #457dff",
    },
    ".cm-searchMatch.cm-searchMatch-selected": {
      backgroundColor: "#6199ff2f",
    },
    ".cm-activeLine": { backgroundColor: background },
    ".cm-selectionMatch": { backgroundColor: "#aafe661a" },
    "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
      backgroundColor: "#bad0f847",
      outline: "1px solid #515a6b",
    },
    ".cm-gutters": {
      backgroundColor: background,
      color: stone,
      border: "none",
      borderRadius: "0.75rem",
    },
    ".cm-activeLineGutter": {
      backgroundColor: background,
    },
    ".cm-lineNumbers .cm-activeLineGutter:nth-child(2)": {
      borderTopLeftRadius: "0.75rem",
    },
    ".cm-lineNumbers .cm-activeLineGutter:last-child": {
      borderBottomLeftRadius: "0.75rem",
    },
    ".cm-content .cm-activeLine:first-child": {
      borderTopRightRadius: "0.75rem",
    },
    ".cm-content .cm-activeLine:last-child": {
      borderBottomRightRadius: "0.75rem",
    },
    ".cm-foldPlaceholder": {
      backgroundColor: "transparent",
      border: "none",
      color: "#ddd",
    },
    ".cm-tooltip": {
      border: "none",
      backgroundColor: tooltipBackground,
    },
    ".cm-tooltip .cm-tooltip-arrow:before": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent",
    },
    ".cm-tooltip .cm-tooltip-arrow:after": {
      borderTopColor: tooltipBackground,
      borderBottomColor: tooltipBackground,
    },
    ".cm-tooltip-autocomplete": {
      "& > ul > li[aria-selected]": {
        backgroundColor: highlightBackground,
        color: ivory,
      },
    },
  },
  { dark: true }
)
/**
The highlighting style for code in the One Dark theme.
*/
const LabeledTextFieldkHighlightStyle = HighlightStyle.define([
  { tag: tags.keyword, color: violet },
  {
    tag: [tags.name, tags.deleted, tags.character, tags.propertyName, tags.macroName],
    color: coral,
  },
  { tag: [tags.function(tags.variableName), tags.labelName], color: malibu },
  {
    tag: [tags.color, tags.constant(tags.name), tags.standard(tags.name)],
    color: whiskey,
  },
  { tag: [tags.definition(tags.name), tags.separator], color: ivory },
  {
    tag: [
      tags.typeName,
      tags.className,
      tags.number,
      tags.changed,
      tags.annotation,
      tags.modifier,
      tags.self,
      tags.namespace,
    ],
    color: chalky,
  },
  {
    tag: [
      tags.operator,
      tags.operatorKeyword,
      tags.url,
      tags.escape,
      tags.regexp,
      tags.link,
      tags.special(tags.string),
    ],
    color: cyan,
  },
  { tag: [tags.meta, tags.comment], color: stone },
  { tag: tags.strong, fontWeight: "bold" },
  { tag: tags.emphasis, fontStyle: "italic" },
  { tag: tags.strikethrough, textDecoration: "line-through" },
  { tag: tags.link, color: stone, textDecoration: "underline" },
  { tag: tags.heading, fontWeight: "bold", color: coral },
  { tag: [tags.atom, tags.bool, tags.special(tags.variableName)], color: whiskey },
  { tag: [tags.processingInstruction, tags.string, tags.inserted], color: sage },
  { tag: tags.invalid, color: invalid },
])
/**
Extension to enable the One Dark theme (both the editor theme and
the highlight style).
*/
const superwallCodeMirrorTheme = [LabeledTextFieldTheme, LabeledTextFieldkHighlightStyle]

export default superwallCodeMirrorTheme
